<template>
    <div class="device-card" @click="navigateToPreview">
        <img :src="device.imageCdnPath || '/placeholder-phone.svg'" :alt="device.model" class="device-image" @error="handleImageError">
        <h3>{{ device.model }}</h3>
        <p><strong>ID:</strong> <span class="device-id" :class="{ 'invalid-tag': !isValidTag(device.id) }">{{ device.id }}</span></p>
        <p class="last-taken"><strong>Last Taken By:</strong>
            <span :class="device.lastTakenBy ? 'taken' : 'available'">
        {{ device.lastTakenBy || "No one" }}
      </span>
        </p>
    </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router'
import {COLORS, GRADIENTS} from "@/styles/brand";

const router = useRouter()
const route = useRoute()

const props = defineProps({
    device: {
        type: Object,
        required: true,
        validator: (device) => {
            return device.id;
        },
    },
});

const navigateToPreview = () => {
    router.push({ path: `/preview/${props.device.id}`, query: route.query })
}

const handleImageError = (e) => {
    e.target.src = '/placeholder-phone.svg'
}

const isValidTag = (id) => {
    return /^TAG-\d+$/.test(id)
}
</script>

<style scoped>
.device-card {
    background: v-bind('GRADIENTS.CARD');
    backdrop-filter: blur(20px);
    border: 3px solid rgba(255, 255, 255, 0.1);
    padding: 24px;
    border-radius: 20px;
    text-align: center;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    position: relative;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.device-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    transition: left 0.6s;
}

.device-card:hover::before {
    left: 100%;
}

.device-card:hover {
    transform: translateY(-12px) scale(1.03);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
    border-color: v-bind('COLORS.PRIMARY.RED');
    background: linear-gradient(145deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.1) 100%);
}

.device-image {
    width: 230px;
    height: 240px;
    object-fit: cover;
    margin: 0 auto 5px;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease;
}

.device-card:hover .device-image {
    transform: scale(1.05);
}

.device-card h3 {
    color: v-bind('COLORS.PRIMARY.WHITE');
    font-size: 1.2rem;
    font-weight: 600;
    margin: 0 0 12px 0;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.device-card p {
    color: rgba(255, 255, 255, 0.8);
    margin: 8px 0;
    font-size: 0.9rem;
}

.device-card strong {
    color: v-bind('COLORS.PRIMARY.WHITE');
    font-weight: 600;
}

.taken {
    color: v-bind('COLORS.SECONDARY.BLACK');
    font-weight: 200;
    padding: 4px 4px;
    margin: 0 8px;
    background: v-bind('COLORS.PRIMARY.WHITE + "90"');
    border-radius: 12px;
    border: 2px solid v-bind('COLORS.PRIMARY.WHITE + "4D"');
}

.available {
    color: v-bind('COLORS.SECONDARY.GREEN');
    font-weight: 600;
    padding: 4px 12px;
}

.last-taken {
    white-space: nowrap;
}

.device-id {
    background: v-bind('COLORS.PRIMARY.RED + "80"');
    color: v-bind('COLORS.PRIMARY.WHITE');
    padding: 2px 8px;
    border-radius: 8px;
    font-weight: 600;
}

.device-id.invalid-tag {
    background: #000000;
    color: v-bind('COLORS.PRIMARY.WHITE');
}

.device-card p:has(.device-id) {
    margin-bottom: 16px;
}
</style>
